/* eslint-disable no-console */
import React, { useCallback } from 'react';
import { useNotify, useUpdate, useRefresh, useTranslate } from 'react-admin';
import Switch from '@material-ui/core/Switch';
import CircularProgress from '@material-ui/core/CircularProgress';

const ActiveToggle = ({ record }) => {
  const translate = useTranslate();
  const notify = useNotify();
  const refresh = useRefresh();

  const [update, { loading }] = useUpdate(
    'InteractionTypeGroup',
    record.id,
    { ...record, active: !record.active },
    record,
    {
      returnPromise: true,
      onSuccess: () => {
        notify(translate('ra.notification.updated'), 'info');
        refresh();
      },
      onError: (error) => {
        notify(translate('ra.page.error'), 'warning');
        console.error(error);
      }
    }
  );

  const handleToggle = useCallback(() => {
    update();
  }, [update]);

  if (loading) {
    return <CircularProgress size={20} />;
  }

  return (
    <Switch
      checked={!!record.active}
      onChange={handleToggle}
      color="primary"
      inputProps={{ 'aria-label': 'Active Toggle' }}
    />
  );
};

export default ActiveToggle;
